import type { StudioDocument } from './studio-api';
import { record, rows, text } from './studio-content';

export interface TrendFrame {
  url: string;
  video: boolean;
}

/** Кадры превью шаблона строки (previews: [{url, mime}]): свои у строки главной или у инструмента, который она открывает.
    Каждый кадр — своя плитка коллажа; не больше 5, как портретов. Только https — адрес уходит прямо в <img>/<video> */
export function trendPreview(item: Record<string, unknown>, tool?: StudioDocument): TrendFrame[] {
  const own = rows(item.previews);
  return (own.length ? own : rows(tool?.previews))
    .map(frame => ({ url: text(record(frame).url), video: text(record(frame).mime).startsWith('video/') }))
    .filter(frame => frame.url.startsWith('https://'))
    .slice(0, 5);
}

/** Веер карточки «Все инструменты»: по кадру с разных шаблонов, которые открывают инструменты, — до 4 плиток вместо портретов.
    С шаблона берём последний кадр: главный кадр ставят не первым (первую плитку строки тренда скрывает растворение) */
export function fanPreview(tools?: StudioDocument[]): TrendFrame[] {
  const frames = new Map<string, TrendFrame>();
  for (const tool of tools ?? []) {
    const frame = trendPreview({}, tool).at(-1);
    if (frame && !frames.has(frame.url)) frames.set(frame.url, frame);
  }
  return [...frames.values()].slice(0, 4);
}
